import { ThemeProvider } from '@material-ui/styles';
import { useStoreRehydrated } from 'easy-peasy';
import { ReactElement } from 'react';

import PanicRequestsProvider from '~/services/socket/PanicRequestsProvider';
import { useStoreActions } from '~/store/hooks';
import BugsnagClient from '../utils/error/bugsnag';
import useGlobalError from '~/hooks/error/useGlobalError';

import Routes from './Routes';
import Loader from './components/common/Loader';
import ReleaseAlert from './pages/Notifications/components/ReleaseAlert';
import SignalRSOS from './pages/Notifications/components/SignalRSOS';
import SystemAlert from './pages/Notifications/components/SystemAlerts/components/SystemAlert';
import muiTheme from './themes/muiTheme';

import './assets/styles/app.scss';

BugsnagClient.startSession();

const App = (): ReactElement => {
  const isRehydrated = useStoreRehydrated();
  useGlobalError();
  const onCheckAuthorization = useStoreActions(actions => actions.user.onCheckAuthorization);
  onCheckAuthorization();

  return (
    <PanicRequestsProvider>
      <ThemeProvider theme={muiTheme}>
        <>
          {isRehydrated ? <Routes /> : <Loader />}
          <SignalRSOS.SignalRSOSAlert />
          <ReleaseAlert />
          <SystemAlert />
        </>
      </ThemeProvider>
    </PanicRequestsProvider>
  );
};
export default App;
